// extracted by mini-css-extract-plugin
export const root = "image-grid-quote-module--root--3kNoy";
export const quote = "image-grid-quote-module--quote--18Y6n";
export const caption = "image-grid-quote-module--caption--3mMVA";